/*
 * reveal.js — SF Oct 31: scroll-reveal switched OFF (see reveal.css).
 *
 * Marks every [data-reveal] element visible immediately, so any style that still waits
 * for `.is-visible` shows at once. No scroll watching, and nothing is hidden while the
 * customer scrolls.
 */
(() => {
  'use strict';

  const revealAll = (root) => {
    if (root instanceof Element && root.hasAttribute('data-reveal')) root.classList.add('is-visible');
    for (const el of root.querySelectorAll('[data-reveal]:not(.is-visible)')) el.classList.add('is-visible');
  };

  const init = () => {
    revealAll(document);

    // Sections drawn again later (filters, theme editor) are revealed too.
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) revealAll(/** @type {Element} */ (node));
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
